/**
 * TagPresentation — helpers d'affichage/layout extraits de Tag (ha/443c).
 *
 * Audit SoC ha/443 : la présentation (mesure de hauteur, show/hide, focus,
 * scroll) n'est pas « ce qu'un Tag EST ». On la sort en fonctions pures
 * opérant sur l'`HTMLElement`, testables et réutilisables hors d'un Tag.
 * `Tag` ne garde que de minces délégations + le plumbing de SA donnée
 * (`visibility` dans la Map data, lue/écrite par Tag qui en est le seul
 * propriétaire ; encapsulation HAObject `protected` préservée).
 *
 * Iso-comportement strict vs Tag legacy :
 *  - `show`/`hide`/`invisible` manipulaient les classes via `addClass`/
 *    `removeClass` avec des noms littéraux ("show"/"hide"/"invisible", sans
 *    `#`) → équivalent direct `classList.add/remove` (pas de chemin i18n).
 *  - l'ordre removeClass→(store visibility)→addClass de `hide` est conservé :
 *    `getVisibility` lit `style.display` (inline), insensible aux classes.
 */

export function fixHeight(el: HTMLElement): void {
    const cs = window.getComputedStyle(el);
    el.style.height = "inherit";
    const height = parseInt(cs.getPropertyValue("border-top-width"), 10)
        + parseInt(cs.getPropertyValue("padding-top"), 10)
        + el.scrollHeight
        + parseInt(cs.getPropertyValue("padding-bottom"), 10)
        + parseInt(cs.getPropertyValue("border-bottom-width"), 10);
    el.style.height = height + "px";
}

export function focus(el: HTMLElement): void {
    el.focus();
}

export function scrollIntoView(el: HTMLElement): void {
    el.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
}

export function getVisibility(el: HTMLElement, defaut?: any): any {
    return el.style.display || defaut;
}

export function show(el: HTMLElement, visibility: any): void {
    el.classList.remove("hide");
    el.classList.add("show");
    el.style.display = visibility;
}

export function hide(el: HTMLElement): void {
    el.classList.remove("show");
    el.classList.add("hide");
}

export function invisible(el: HTMLElement): void {
    el.classList.add("invisible");
}
